// EXPORTS //

export default function preventEventDefault( e ) {
	e.preventDefault();
}
